import { render, staticRenderFns } from "./ControlPanelIcon.vue?vue&type=template&id=07b1956c"
import script from "./ControlPanelIcon.vue?vue&type=script&lang=js"
export * from "./ControlPanelIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports